import { useEffect, useState } from "react";
import useDebounce from "./useDebounce";

const useImageGallery = () => {
    const [thumbsSlider, setThumbsSlider] = useState(null);
    const [slideshowSlider, setSlideshowSlider] = useState(null);
    const [debouncedIndex, setDebouncedIndex] = useState("");
    // const debouncedValue = useDebounce(debouncedIndex, 375);
    //
    // useEffect(() => {
    //     thumbsSlider?.slickGoTo(debouncedIndex);
    // }, [debouncedValue]);

    const slideTo = (index) => {
        thumbsSlider?.slickGoTo(index);
        setDebouncedIndex(index);
    };

    return {
        thumbsSlider,
        slideshowSlider,
        setThumbsSlider,
        setSlideshowSlider,
        slideTo,
    };
};

export default useImageGallery;
